export default {
	service: ["Service", "Événement", "Retrait", "Dépôt", "CGU", "Certificat", "FAQs", "Guide de l'utilisateur", "VIP"],
	sign: {
		title: "Connecté pour {0} jour",
		SignIn: "Se connecter"
	},
	hotMusicAlbum: "Album de Musique Populaire",
	hotMusic: "Classements des Chansons Populaires",
	popular: "Nouvelle Lecture",
	rankings: "Films populaires",
	top: "TOP{0}",
	OnchainServices: "Services Onchain",
	Real: {
		title: "Temps réel",
		list: [
			"Nombre total d'utilisateurs en ligne",
			"Volume moyen d'optimisation par utilisateur",
			"Carte thermique des besoins d'optimisation",
			"Quantité d'optimisation de promotion de la plateforme"
		]
	},
	work: {
		title: "Récompense pour la soumission d'une commande",
		SignIn: "Obtenir"
	},
	Profit: {
		Profit: "Profit",
		tabs: ["Profit", "Bonus", "Compte"],
		TotalBalance: "Solde Total",
		TotalLuckyBonus: "Bonus Chance Total",
		todayEarnings: "Gains du Jour",
		availableBalance: "Solde Disponible",
		title: ["Gains du Jour", "Gains Totals", "Compte"],
		list: ["Gains de Commande", "Gains de l'Équipe", "Gains Totals"],
		order: {
			title: "Profit de Commande",
			commission: "Commission de Commande"
		},
		Analysis: {
			title: "Analyse des Profits",
			tips: "Vous avez effectué {0} transactions",
			tabs: ["Profit du Jour", "Profit Total"],
			totalTitle: ["Profit de Commande", "Profit d'Enregistrement", "Profit de l'Équipe", "Profit de Bonus"]
		}
	},
	CustomerService: {
		title: "Centre de Service Client",
		consultation: "Consultation du Service Client",
		btn: "Contactez-nous",
		noticeTitle: "Notification du Système"
	},
	addWallet: "Ajouter un portefeuille",
	taskProgress: "Progression des tâches quotidiennes",
	currentProgress: "Progression actuelle de la tâche",
	awardsBulletin: `{0} utilisateur gagne {1} {2} prix dans la tâche.`,
	vip: {
		title: "@:vip.title",
		more: "Voir plus"
	},
	stats: {
		title: "Sources de données - Tableau de bord et API",
		subTitle: "Statistiques des artistes",
		list: ["Métriques", "Artistes avec réseaux sociaux actifs", "Mis à jour quotidiennement"]
	}
};
